import { render, staticRenderFns } from "./CoilGridComponent.vue?vue&type=template&id=c4af0788&"
import script from "./CoilGridComponent.vue?vue&type=script&lang=js&"
export * from "./CoilGridComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports